/*
 * Formats cents value to currency
 *
 * @unstable
 */

import { Store } from '@ngxs/store';

import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

import { PrefsState } from '@shared/states/prefs.state';

@Pipe({
  name: 'currencyCent',
  standalone: false,
})
@Injectable({ providedIn: 'root' })
export class CurrencyCent extends CurrencyPipe implements PipeTransform {
  public store = inject(Store);

  transform(
    value: number | string,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
    locale?: string,
  ): string | null;
  transform(
    value: null | undefined,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
    locale?: string,
  ): null;
  transform(
    value: any,
    currencyCode?: string,
    display?: 'code' | 'symbol' | 'symbol-narrow' | string | boolean,
    digitsInfo?: string,
    locale?: string,
  ): string | null {
    value = parseInt(value, 10) || 0;

    if (typeof value === 'number') {
      const neg = value < 0;
      value = value.toFixed(0).substr(neg ? 1 : 0);

      if (value.length === 1) {
        value = `0.0${value}`;
      } else if (value.length === 2) {
        value = `0.${value}`;
      } else {
        value = `${value.substr(0, value.length - 2)}.${value.substr(-2)}`;
      }

      if (neg) {
        value = `-${value}`;
      }

      value = parseFloat(value);
    }

    if (!locale) {
      locale = this.store.selectSnapshot(PrefsState.locale);
    }

    return super.transform(value, currencyCode, display, digitsInfo, locale);
  }
}
